import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/LayoutContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/src/context/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/tailwind.css");
